import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react-lite';
import { Snackbar } from '@material-ui/core';
import { snackbarState, hideSnackbar } from './state';
import './styles.scss';

const ErrorSnackbar = observer(() => {
  return (
    <Snackbar
      open={snackbarState.isOpen}
      autoHideDuration={snackbarState.autoHideDuration}
      onClose={hideSnackbar}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <div className="error-snackbar">
        <div className="error-snackbar__content">
          <img
            src="https://cdn.shopify.com/s/files/1/0136/6867/9739/files/Alert.svg?v=1760505893"
            alt="Error"
            className="error-snackbar__icon"
          />
          <span className="error-snackbar__message">{snackbarState.message}</span>
        </div>
        <button className="error-snackbar__close" type="button" onClick={hideSnackbar} aria-label="close">
          <img
            src="https://cdn.shopify.com/s/files/1/0136/6867/9739/files/Close_X.svg?v=1760506800"
            alt="Close"
            className="error-snackbar__close-icon"
          />
        </button>
      </div>
    </Snackbar>
  );
});

const renderErrorSnackbar = () => {
  const mountNode = document.querySelector('[react-render-target="ErrorSnackbar"]');
  if (mountNode) ReactDOM.render(<ErrorSnackbar />, mountNode);
  else console.warn('missing render target: ErrorSnackbar');
};

export const initErrorSnackbar = () => {
  renderErrorSnackbar();
};

export interface SnackbarState {
  isOpen: boolean;
  message: string;
  autoHideDuration: number;
}
